<ul class="filing-manager-toc-nested-items-container">
  <li *ngFor="let question of filteredQuestions; let i = index; trackBy: trackByQuestionKey" class="toc-nested-items-list"
      [ngStyle]="getListStyle(question)"
      [ngClass]="{'group-field': question.dataType === 'Group' && !question.isMultiResponse,
                    'multi-response-field': question.dataType === 'Group' && question.isMultiResponse,
                    'regular-field': question.dataType !== 'Group'}">

    <mat-accordion *ngIf="question.isMultiResponse === true; else normalToc" [multi]="false">
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'"
                                    [ngStyle]="getMatHeaderStyle(question)"
                                    class="multi-response-group-title">
          <mat-panel-title>
            <span class="toc-title" title="{{ getDisplayTitle(question) }}">
              {{ getDisplayTitle(question) }}
            </span>
            <span *ngIf="question.dataType === 'Group' && getErrorCount(question)>0" class="error-count"
                  title="{{this.errorCountToolTip}}">
              <i class="fa-solid fa-triangle-exclamation"></i>{{getErrorCount(question)}}
            </span>

          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-panel-content *ngIf="question.questions?.length" class="toc-nested-list">
          <ul>
            <li *ngFor="let dataItem of question.questions; trackBy: trackByQuestionKey; let di = index" class="toc-nested-item"
                [ngStyle]="getListStyle(question, level+1)"
                [ngClass]="dataItem.dataType === 'Group' ? 'group-field' : 'regular-field'">
              <mat-accordion>
                <mat-expansion-panel (opened)="onSectionExpanded(dataItem)">
                  <mat-expansion-panel-header class="multi-response-item-auto-title"
                                              [ngStyle]="getMatHeaderStyle(question, level+1)"
                  >
                    <mat-panel-title>
                                            <span class="toc-title"
                                                  title="Response-{{ di + 1 }}">Response-{{ di + 1 }}</span>
                      <span *ngIf="dataItem.dataType === 'Group' && getErrorCount(dataItem)>0"
                            class="error-count" title="{{this.errorCountToolTip}}">
              <i class="fa-solid fa-triangle-exclamation"></i>{{getErrorCount(dataItem)}}
            </span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-panel-content>

                    <app-elite-form-table-of-contents-item *ngIf="dataItem.questions?.length"
                                                           [questions]="dataItem.questions"
                                                           [level]="level+2"
                                                           [currentField]="dataItem"
                                                           [parentIndex]="parentIndex + (di + 1) + '.'">
                    </app-elite-form-table-of-contents-item>

                  </mat-panel-content>
                </mat-expansion-panel>
              </mat-accordion>

            </li>
          </ul>

        </mat-panel-content>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-template #normalToc>
      <mat-accordion class="toc-regular-field-accordion"
                     *ngIf="question.dataType === 'Group'; else PrimitiveField" [multi]="false">
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'"
                                      class="regular-group-title" [ngStyle]="getMatHeaderStyle(question)">
            <mat-panel-title (click)="scrollToField(question.fieldKey, parentIndex, question.dataItemId)">
                            <span class="truncate"
                                  title="{{ getDisplayTitle(question) }}">{{ getDisplayTitle(question) }}</span>&nbsp;
              <span *ngIf="question.dataType === 'Group' && getErrorCount(question)>0"
                    class="error-count" title="{{this.errorCountToolTip}}">
              <i class="fa-solid fa-triangle-exclamation"></i>{{getErrorCount(question)}}
            </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-panel-content>
            <app-elite-form-table-of-contents-item *ngIf="question.questions?.length"
                                                   [questions]="question.questions"
                                                   [level]="level+1"
                                                   [currentField]="question"
                                                   class="toc-regular-field_child-component"
                                                   [parentIndex]="parentIndex + (i + 1) + '.'">
            </app-elite-form-table-of-contents-item>
          </mat-panel-content>
        </mat-expansion-panel>
      </mat-accordion>

      <ng-template #PrimitiveField>
        <div title="{{getDisplayTitle(question)}}" class="primitive-field pointer"
             (click)="scrollToField(question.fieldKey, parentIndex, question.dataItemId)">
          <span class="data">
            {{ getDisplayTitle(question) }}
          </span>
          <span *ngIf="getErrorCount(question)>0"
                class="error-count" title="{{this.errorCountToolTip}}">
              <i class="fa-solid fa-triangle-exclamation"></i>
          </span>
        </div>

      </ng-template>
    </ng-template>
  </li>
</ul>
